import { IconProps } from '../icon';

export function LogoReduitWhiteIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="266.029"
      height="225.177"
      viewBox="0 0 266.029 225.177"
      {...props}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_390"
            data-name="Rectangle 390"
            width="266.029"
            height="225.177"
            fill="#fff"
          />
        </clipPath>
      </defs>
      <g
        id="Groupe_5946"
        data-name="Groupe 5946"
        transform="translate(-101 -34)"
      >
        <g
          id="Groupe_5945"
          data-name="Groupe 5945"
          transform="translate(101 34)"
          clipPath="url(#clipPath)"
        >
          <path
            id="Tracé_604"
            data-name="Tracé 604"
            d="M211.1,79.208l.036,31.544.005,4.215-3.936,1.516-71.931,27.686-2.2.849-2.2-.849-71.95-27.683-3.931-1.515V79.191C21.671,88.713,0,104.171,0,121.625c0,28.937,59.552,52.4,133.014,52.4s133.015-23.461,133.015-52.4c0-17.443-21.646-32.893-54.928-42.417"
            fill="#fff"
          />
          <path
            id="Tracé_605"
            data-name="Tracé 605"
            d="M187.822,39.785,135.579,59.916V78.538l52.311,20.135-.029-24.8Z"
            fill="#fff"
          />
          <path
            id="Tracé_606"
            data-name="Tracé 606"
            d="M183.355,36.126,133.182,16.737,78.23,37.854v62.754l52.331,20.132V58.194h0a2.486,2.486,0,0,1,.4-1.345.632.632,0,0,1,.036-.074c.038-.057.1-.1.14-.151a2.407,2.407,0,0,1,.416-.422,2.5,2.5,0,0,1,.61-.35l16.349-6.3Z"
            fill="#fff"
          />
          <path
            id="Tracé_607"
            data-name="Tracé 607"
            d="M204.965,77.55,204.909,27.7,133.216,0l-72.1,27.7v83.056l71.951,27.684L205,110.758Zm-14.552,27.287H190.4a2.5,2.5,0,0,1-.9-.167L135.579,83.915v40.241c.006.078.01.158.01.239a2.509,2.509,0,0,1-2.508,2.51h-.01a2.5,2.5,0,0,1-.9-.168L74.821,104.671a2.509,2.509,0,0,1-1.609-2.342v-66.2a2.508,2.508,0,0,1,1.609-2.341l57.463-22.082a2.493,2.493,0,0,1,1.805,0L191.2,33.778h0l.026.01c.024.009.042.028.066.038a2.445,2.445,0,0,1,.448.233c.029.02.049.047.077.067.064.048.118.1.178.157a2.533,2.533,0,0,1,.312.335c.049.065.094.129.137.2a2.452,2.452,0,0,1,.206.425c.026.067.057.13.077.2a2.491,2.491,0,0,1,.1.685l.044,38.7.031,27.261c.008.08.012.161.012.241a2.509,2.509,0,0,1-2.51,2.509"
            fill="#fff"
          />
          <path
            id="Tracé_608"
            data-name="Tracé 608"
            d="M67.552,205.9a10.7,10.7,0,0,0-7.4-2.961c-6.744,0-10.2,4.935-10.166,10.265,0,5.429,3.455,10.1,10.166,10.1a10.391,10.391,0,0,0,7.009-2.665v-6.449H59.13v-1.547h9.7v8.62a11.893,11.893,0,0,1-8.686,3.719c-7.83,0-11.877-5.462-11.877-11.746-.033-7.206,4.87-11.91,11.877-11.91a11.989,11.989,0,0,1,8.423,3.454Z"
            fill="#fff"
          />
          <path
            id="Tracé_609"
            data-name="Tracé 609"
            d="M91.7,224.684H89.367L81.4,215.965H75.121v8.719H73.344V201.653H83.478a7.121,7.121,0,0,1,7.568,7.172c.032,3.751-2.436,7.041-7.469,7.041Zm-16.583-10.4H83.28c4.015,0,5.791-2.27,5.823-5.494a5.306,5.306,0,0,0-5.625-5.495H75.121Z"
            fill="#fff"
          />
          <path
            id="Tracé_610"
            data-name="Tracé 610"
            d="M96.408,212.28H109.9v1.612H96.408v9.081H110.95v1.711H94.663V201.653h15.892v1.678H96.408Z"
            fill="#fff"
          />
          <path
            id="Tracé_611"
            data-name="Tracé 611"
            d="M116.61,212.28H130.1v1.612H116.61v9.081h14.542v1.711H114.866V201.653h15.891v1.678H116.61Z"
            fill="#fff"
          />
          <path
            id="Tracé_612"
            data-name="Tracé 612"
            d="M136.549,201.653l15.495,19.05v-19.05h1.745v23.031H153.1l-15.53-19.017v19.017h-1.776V201.653Z"
            fill="#fff"
          />
          <path
            id="Tracé_613"
            data-name="Tracé 613"
            d="M176.919,201.785l-10.233,11.022,11.088,11.614v.263h-5.363l-9.64-10.2v10.2h-4.343V201.653h4.343v9.739l8.752-9.739h5.4Z"
            fill="#fff"
          />
          <path
            id="Tracé_614"
            data-name="Tracé 614"
            d="M199.127,201.686v13.193c0,6.811-4.179,10.3-9.969,10.3-5.528,0-10.232-3.356-10.232-10.3V201.686h4.309v13.193c0,4.145,2.37,6.35,5.956,6.35s5.625-2.4,5.625-6.35V201.686Z"
            fill="#fff"
          />
          <path
            id="Tracé_615"
            data-name="Tracé 615"
            d="M222.093,208.332a4.685,4.685,0,0,1-2.994,4.442,5.616,5.616,0,0,1,3.685,5.132c0,5.133-3.85,6.778-8.621,6.778H203.24V201.653h10.923c4.541,0,7.93,2.04,7.93,6.679M207.517,210.9h6.646c2.732,0,3.62-1.152,3.62-2.467,0-1.053-.856-2.83-3.62-2.83h-6.646Zm0,9.739h6.646c1.777,0,4.311-.592,4.311-2.764,0-2.072-2.534-3.158-4.311-3.158h-6.646Z"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}

export default LogoReduitWhiteIcon;
